"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTestNotification = exports.callApi = void 0;
const react_1 = __importStar(require("react"));
const notification_context_1 = require("../../notification/notification-context");
const detail_context_1 = require("../../../composite/detail/detail-context");
const detail_types_1 = require("../../../composite/detail/detail-types");
const snackbar_context_1 = require("../../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../../composite/snackbar/snackbar-types");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
/**
 * Api call
 *
 * @param id
 */
function callApi(template, templateUrl) {
    var _a;
    return (0, abortable_fetch_1.abortableFetch)(`${templateUrl}/test`, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
            template: {
                ...template,
                event: (_a = template === null || template === void 0 ? void 0 : template.event) === null || _a === void 0 ? void 0 : _a.id,
            },
        }),
    });
}
exports.callApi = callApi;
function useTestNotification() {
    /**
     * Context stuff.
     */
    const { source, mode } = (0, react_1.useContext)(detail_context_1.DetailContext);
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const { formRef, validate } = (0, react_1.useContext)(detail_context_1.DetailContext);
    const { notificationTemplateUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    /**
     * Fetch ref.
     */
    const fetch = (0, react_1.useRef)(null);
    const handleTestNotification = (0, event_callback_hook_1.useEventCallback)(async () => {
        try {
            source.setLoading(true);
            const errors = await validate();
            if (errors.length === 0) {
                const values = formRef === null || formRef === void 0 ? void 0 : formRef.getFieldValues();
                if (fetch.current !== null) {
                    fetch.current.abort();
                }
                fetch.current = callApi(values, notificationTemplateUrl);
                const response = await fetch.current.json();
                showSnackbar(react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    react_1.default.createElement("u", null, "Titulek:"),
                    react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: response.subject } }),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("u", null, "Obsah:"),
                    react_1.default.createElement("iframe", { id: "test", name: "test", sandbox: "allow-same-origin", style: {
                            width: 600,
                            height: 600,
                            border: 0,
                        }, srcDoc: response.content })), snackbar_types_1.SnackbarVariant.BLANK);
            }
        }
        catch (err) {
            return undefined;
        }
        finally {
            source.setLoading(false);
        }
    });
    const showTestNotificationButton = mode !== detail_types_1.DetailMode.NONE;
    return {
        handleTestNotification,
        showTestNotificationButton,
    };
}
exports.useTestNotification = useTestNotification;
//# sourceMappingURL=test-hook.js.map